import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getSubscriptions } from "../../../redux/pricing-plan/action";

function UseFetchSubscription() {
  const {
    main: { userData },
    pricingPlan: { subscriptions, getSubscriptionLoading, subscriptionError },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      userData?.email &&
      !Object.keys(subscriptions).length &&
      !getSubscriptionLoading &&
      !subscriptionError
    ) {
      dispatch(
        getSubscriptions(
          userData["cognito:username"],
          userData?.["custom:custom_username"],
        ),
      );
    }
  }, [
    userData,
    subscriptions,
    getSubscriptionLoading,
    subscriptionError,
    dispatch,
  ]);

  return { loading: getSubscriptionLoading };
}

export default UseFetchSubscription;
